module.exports = __webpack_public_path__ + "static/media/css-cheatsheet.7b307384.png";